import React from 'react';
import PropTypes from 'prop-types';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import { ITINERARY_FOOD_INVOICE_PATH } from '../../../../config/paths';
import ItineraryFoodInvoiceForm from './ItineraryFoodInvoiceForm';
import { postItineraryFoodInvoice } from '../../../../actions/food/ItineraryFoodInvoice';
import { tzNormalizeDate } from '../../../../utils/date';

const NewInvoiceFoodInvoice = ({
  breadcrumbs,
  dispatchPostItineraryFoodInvoice,
}) => {
  const onSubmit = (formValues, selectedSupplier) => {
    if (!selectedSupplier) {
      toastr.error('Debe buscar un proveedor.');
      return;
    }

    if (
      !formValues.itinerarySupplierFoodDetailList ||
      formValues.itinerarySupplierFoodDetailList.length === 0
    ) {
      toastr.error('Debe seleccionar al menos un viaje.');
      return;
    }

    const newFormValues = {
      supplierId: formValues.supplierId,
      documentSeries: formValues.documentSeries,
      documentCode: formValues.documentCode,
      amount: formValues.amount,
      summaryNumber: formValues.summaryNumber,
      description: formValues.description,
      accountingDeliveredDate: formValues.accountingDeliveredDate
        ? tzNormalizeDate({
            date: formValues.accountingDeliveredDate,
          })
        : null,
      issueDate: formValues.issueDate
        ? tzNormalizeDate({
            date: formValues.issueDate,
          })
        : null,
      expirationDate: formValues.expirationDate
        ? tzNormalizeDate({
            date: formValues.expirationDate,
          })
        : null,
      periodStartDate: formValues.periodStartDate
        ? tzNormalizeDate({
            date: formValues.periodStartDate,
          })
        : null,
      periodEndDate: formValues.periodEndDate
        ? tzNormalizeDate({
            date: formValues.periodEndDate,
          })
        : null,
      itinerarySupplierFoodDetailList:
        formValues.itinerarySupplierFoodDetailList.map((item) => ({
          id: item,
        })),
    };

    dispatchPostItineraryFoodInvoice(newFormValues);
  };

  const content = <ItineraryFoodInvoiceForm onSubmit={onSubmit} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Factura de Alimentación de Itinerarios"
      subtitle="Crear factura de alimentación de itinerario"
      content={content}
    />
  );
};

NewInvoiceFoodInvoice.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostItineraryFoodInvoice: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostItineraryFoodInvoice: postItineraryFoodInvoice,
};

const mapStateToProps = ({ FoodUnit }) => ({
  breadcrumbs: [
    ...FoodUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Facturas de Alimentación de Itinerarios',
      href: ITINERARY_FOOD_INVOICE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewInvoiceFoodInvoice);
